<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(14)"
      :class="index == 14 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 14" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 14"
      />
      <div>库存区</div>
    </div>
    <div
      class="button"
      @click="selectMenu(15)"
      :class="index == 15 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 15" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 15"
      />
      <div>今日入库信息</div>
    </div>
    <div
      class="button"
      @click="selectMenu(16)"
      :class="index == 16 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 16" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 16"
      />
      <div>安全监控</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>

</style>
